import { render, staticRenderFns } from "./hollandChart.vue?vue&type=template&id=fed31178&scoped=true&"
import script from "./hollandChart.vue?vue&type=script&lang=js&"
export * from "./hollandChart.vue?vue&type=script&lang=js&"
import style0 from "./hollandChart.vue?vue&type=style&index=0&id=fed31178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed31178",
  null
  
)

export default component.exports